/**
 * Cards de status da DLQ de contratos
 * Exibe total, mensagem mais antiga e mais recente
 */

import { Skull, Clock, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useDlqContractsStats } from '@/hooks/useDlqContractsMonitor';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function DlqContractsStatusCards() {
  const { data: stats, isLoading } = useDlqContractsStats();

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-3">
        {[...Array(3)].map((_, i) => (
          <Card key={i}><CardContent className="p-6"><Skeleton className="h-4 w-20 mb-2" /><Skeleton className="h-8 w-16" /></CardContent></Card>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Total na DLQ',
      value: stats?.total || 0,
      icon: Skull,
      color: 'text-red-600',
      bgColor: 'bg-red-100 dark:bg-red-900/20',
    },
    {
      title: 'Mais Antiga',
      value: stats?.oldestAt 
        ? formatDistanceToNow(new Date(stats.oldestAt), { addSuffix: true, locale: ptBR }) 
        : 'N/A',
      icon: Clock,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100 dark:bg-orange-900/20',
    },
    {
      title: 'Mais Recente',
      value: stats?.newestAt
        ? formatDistanceToNow(new Date(stats.newestAt), { addSuffix: true, locale: ptBR })
        : 'N/A',
      icon: AlertTriangle,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100 dark:bg-yellow-900/20',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-3">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">{card.title}</p>
                <p className="text-2xl font-bold">{card.value}</p>
              </div>
              <div className={`p-3 rounded-full ${card.bgColor}`}>
                <card.icon className={`h-5 w-5 ${card.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
